// @ts-nocheck 2d932d28
import { array } from '#packages/util';
import wixFormsConstants from '../../contact/wixForms/constants';
import * as wixFormsUtils from '../../contact/wixForms/utils';

const addForm = (structure) => {
  const form = wixFormsUtils.getFormWidget({
    layout: {
      width: 454,
      height: 305,
      x: 15,
      y: 299,
      scale: 1,
      rotationInDegrees: 0,
      anchors: [
        {
          distance: 68,
          originalValue: 652,
          type: 'BOTTOM_PARENT',
          locked: true,
          targetComponent: 'comp-ioin6kf0',
        },
      ],
      fixedPosition: false,
    },
  });

  // add form to
  // components: [
  //     component_0: {
  //         components: [
  //             form,
  //             component_01
  //         ]
  //     },
  // ]
  return {
    ...structure,
    components: array.immutableSplice(structure.components, 0, 1, {
      ...structure.components[0],
      components: array.immutableSplice(
        structure.components[0].components,
        0,
        0,
        form,
      ),
    }),
  };
};

export default (onDrop, onClick) => (item) => {
  onDrop = onDrop(wixFormsConstants.FormPreset.STRIP01);
  onClick = onClick(wixFormsConstants.FormPreset.STRIP01);

  return {
    ...item,
    onDrop,
    onClick,
    structure: addForm(item.structure),
  };
};
